/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeDoc = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#5C8DFF"></rect>
                        <path
                            d="M10.7928 5C10.6996 5 10.6187 5.06442 10.5979 5.1553L9.54612 9.74221L8.44457 5.15332C8.42299 5.0634 8.34257 5 8.25009 5H7.7658C7.67383 5 7.59372 5.06272 7.57165 5.152L6.43689 9.74221L5.40171 5.15596C5.38112 5.06477 5.30011 5 5.20662 5H4.75038C4.62209 5 4.52697 5.11907 4.55532 5.24419L5.82393 10.8442C5.84457 10.9353 5.92555 11 6.01898 11H6.85743C6.94966 11 7.02992 10.9369 7.05175 10.8473L8 6.95467L8.93171 10.8466C8.95325 10.9365 9.0337 11 9.12622 11H9.96447C10.0577 11 10.1386 10.9356 10.1594 10.8447L11.4439 5.24471C11.4726 5.11946 11.3774 5 11.2489 5H10.7928Z"
                            fill="white"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#5C8DFF"
                        ></path>
                        <path
                            d="M16.4684 7.20001C16.3192 7.20001 16.1899 7.30309 16.1565 7.44849L14.4737 14.7875L12.7112 7.44532C12.6767 7.30145 12.548 7.20001 12.4001 7.20001H11.6252C11.478 7.20001 11.3499 7.30037 11.3145 7.44322L9.49893 14.7875L7.84264 7.44956C7.8097 7.30364 7.68007 7.20001 7.53049 7.20001H6.8005C6.59524 7.20001 6.44306 7.39053 6.48841 7.59071L8.51818 16.5507C8.55121 16.6965 8.68078 16.8 8.83028 16.8H10.1718C10.3194 16.8 10.4478 16.6991 10.4827 16.5557L11.9999 10.3275L13.4906 16.5545C13.5251 16.6985 13.6538 16.8 13.8019 16.8H15.143C15.2922 16.8 15.4216 16.6969 15.4549 16.5516L17.5101 7.59155C17.5561 7.39114 17.4038 7.20001 17.1982 7.20001H16.4684Z"
                            fill="white"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.38989 7.82499C3.38989 4.03079 6.4657 0.954987 10.2599 0.954987H27.948C29.7182 0.954987 31.4201 1.63832 32.6988 2.8625L42.4907 12.2368C43.8444 13.5327 44.6099 15.3254 44.6099 17.1993V42.175C44.6099 45.9692 41.5341 49.045 37.7399 49.045H10.2599C6.4657 49.045 3.38989 45.9692 3.38989 42.175V7.82499Z"
                            fill="#5C8DFF"
                        ></path>
                        <path
                            d="M44.4743 15.84H35.4501C32.2883 15.84 29.7251 13.2768 29.7251 10.115V1.18875C30.8323 1.48525 31.8573 2.05671 32.699 2.86249L42.491 12.2368C43.5123 13.2146 44.1988 14.4751 44.4743 15.84Z"
                            fill="#8BB7FF"
                        ></path>
                        <path
                            d="M44.6101 17.5575H35.4501C31.3397 17.5575 28.0076 14.2254 28.0076 10.115V0.955231C28.5922 0.960284 29.169 1.03984 29.7251 1.18874V10.115C29.7251 13.2768 32.2882 15.84 35.4501 15.84H44.4743C44.5639 16.2841 44.6101 16.7393 44.6101 17.1993V17.5575Z"
                            fill="#2965FF"
                        ></path>
                        <path
                            d="M30.144 23.4C29.9389 23.4 29.761 23.5418 29.7152 23.7417L27.4013 33.8329L24.9779 23.7373C24.9304 23.5395 24.7535 23.4 24.55 23.4H23.4846C23.2822 23.4 23.106 23.538 23.0574 23.7344L20.561 33.8329L18.2836 23.7431C18.2383 23.5425 18.06 23.4 17.8544 23.4H16.8506C16.5684 23.4 16.3591 23.662 16.4215 23.9372L19.2124 36.2572C19.2579 36.4577 19.436 36.6 19.6416 36.6H21.4862C21.6891 36.6 21.8656 36.4613 21.9137 36.2642L23.9998 27.7003L26.0496 36.2625C26.097 36.4604 26.2739 36.6 26.4775 36.6H28.3216C28.5267 36.6 28.7046 36.4583 28.7505 36.2584L31.5763 23.9384C31.6395 23.6628 31.4302 23.4 31.1475 23.4H30.144Z"
                            fill="white"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
